import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import "../Login page/LoginForAdmin.css"
import logo from "../../Assets/EMEI logo.jpeg";
import { DEFAULT_ADMIN_CREDENTIALS, isDefaultAdminAttempt } from "./adminAuth";


const API_URL = "http://localhost:5000/api/admin";

export default function AdminLoginRegister() {

    const navigate = useNavigate();

    //-----------------------------------------------------
    // Toggle Login/Register
    //-----------------------------------------------------

    const [isRegister, setIsRegister] = useState(false);

    //-----------------------------------------------------
    // Loading
    //-----------------------------------------------------

    const [loading, setLoading] = useState(false);

    //-----------------------------------------------------
    // Success/Error Message
    //-----------------------------------------------------

    const [message, setMessage] = useState("");

    //-----------------------------------------------------
    // Login Form
    //-----------------------------------------------------

    const [loginData, setLoginData] = useState({

        username: "",

        email: "",

        securityKey: "",

        password: ""

    });

    //-----------------------------------------------------
    // Register Form
    //-----------------------------------------------------

    const [registerData, setRegisterData] = useState({

        fullname: "",

        username: "",

        email: "",

        phone: "",

        securityKey: "",

        password: "",

        confirmPassword: ""

    });

    //-----------------------------------------------------
    // Handle Login Input
    //-----------------------------------------------------

    const handleLoginChange = (e) => {

        const { name, value } = e.target;

        setLoginData({

            ...loginData,

            [name]: value

        });

    };

    //-----------------------------------------------------
    // Handle Register Input
    //-----------------------------------------------------

    const handleRegisterChange = (e) => {

        const { name, value } = e.target;

        setRegisterData({

            ...registerData,

            [name]: value

        });

    };

    //-----------------------------------------------------
    // Login Submit
    //-----------------------------------------------------

    const handleLogin = async (e) => {

        e.preventDefault();

        setLoading(true);

        setMessage("");

        try {

            if (isDefaultAdminAttempt(loginData)) {
                localStorage.setItem("adminToken", "local-admin-token");
                localStorage.setItem("adminName", DEFAULT_ADMIN_CREDENTIALS.username);
                localStorage.setItem("adminRole", "admin");
                setMessage("Login Successful");
                setTimeout(() => {
                    navigate("/dashboard");
                }, 500);
                return;
            }

            const res = await axios.post(

                `${API_URL}/login`,

                loginData

            );

            const token = res?.data?.token;
            const admin = res?.data?.admin;

            if (!token || !admin) {
                throw new Error("Invalid login response");
            }

            localStorage.setItem(

                "adminToken",

                token

            );

            localStorage.setItem(

                "adminName",

                admin.username

            );

            localStorage.setItem(

                "adminRole",

                admin.role

            );

            setMessage("Login Successful");

            setTimeout(() => {
                navigate("/dashboard");
            }, 500);

        }

        catch (err) {

            setMessage(
                err.response?.data?.message ||
                "Invalid Credentials"
            );

        }

        finally {

            setLoading(false);

        }

    };

    //-----------------------------------------------------
    // Register Submit
    //-----------------------------------------------------

    const handleRegister = async (e) => {

        e.preventDefault();

        setMessage("");

        if (

            registerData.password !==

            registerData.confirmPassword

        ) {

            setMessage(

                "Passwords do not match."

            );

            return;

        }

        setLoading(true);

        try {

            await axios.post(

                `${API_URL}/register`,

                registerData

            );

            setMessage(

                "Administrator Registered Successfully"

            );

            setRegisterData({

                fullname: "",

                username: "",

                email: "",

                phone: "",

                securityKey: "",

                password: "",

                confirmPassword: ""

            });

            setTimeout(() => {

                setIsRegister(false);

            }, 1200);

        }

        catch (err) {

            setMessage(

                err.response?.data?.message ||

                "Registration Failed"

            );

        }

        finally {

            setLoading(false);

        }

    };

    //-----------------------------------------------------
    // Toggle
    //-----------------------------------------------------

    const showLogin = () => {

        setMessage("");

        setIsRegister(false);

    };

    const showRegister = () => {

        setMessage("");

        setIsRegister(true);

    };

    //-----------------------------------------------------
    // JSX START
    //-----------------------------------------------------

return (
<div className="admin-container-logadmin">

    {/* Background Glow */}

    <div className="bg-circle-logadmin bg-circle-one-logadmin"></div>

    <div className="bg-circle-logadmin bg-circle-two-logadmin"></div>


    {/* Authentication Card */}

    <div className="admin-card-logadmin">

  
        {/* Logo */}
<div className="flex20">
    <div className="floating-logo-logadmin">

<img src={logo} alt="Logo"/>

    </div>
</div>



        {/* Heading */}

        <h1>EMEI ADMIN</h1>


        <p className="portal-text-logadmin">

            Administrator Control Center

        </p>



        {/* Tabs */}

        <div className="tabs-logadmin">


            <button
                type="button"
                onClick={showLogin}
                className={!isRegister ? "active-logadmin" : ""}
            >

                Login

            </button>


            <button
                type="button"
                onClick={showRegister}
                className={isRegister ? "active-logadmin" : ""}
            >

                Register

            </button>


        </div>



        {/* Message */}

        {message &&

            <div className="message-logadmin">

                {message}

            </div>

        }




        {!isRegister ? (

       <form
    className="admin-form-logadmin fade-logadmin"
    onSubmit={handleLogin}
>

    <div className="form-grid-logadmin">


        <input
            type="text"
            name="username"
            placeholder="Admin Username"
            value={loginData.username}
            onChange={handleLoginChange}
            required
        />


        <input
            type="email"
            name="email"
            placeholder="Official Email"
            value={loginData.email}
            onChange={handleLoginChange}
            required
        />


        <input
            type="text"
            name="securityKey"
            placeholder="Security Key"
            value={loginData.securityKey}
            onChange={handleLoginChange}
            required
        />


        <input
            type="password"
            name="password"
            placeholder="Password"
            value={loginData.password}
            onChange={handleLoginChange}
            required
        />


    </div>


<button
    type="submit"
    className="btn-login-logadmin"
    disabled={loading}
>

{
    loading
    ? "Authenticating..."
    : "LOGIN"
}

</button>


</form>



        ) : (



<form
    className="admin-form-logadmin fade-logadmin"
    onSubmit={handleRegister}
>

    <div className="form-grid-logadmin">


        <input
            type="text"
            name="fullname"
            placeholder="Full Name"
            value={registerData.fullname}
            onChange={handleRegisterChange}
            required
        />


        <input
            type="text"
            name="username"
            placeholder="Admin Username"
            value={registerData.username}
            onChange={handleRegisterChange}
            required
        />


        <input
            type="email"
            name="email"
            placeholder="Official Email"
            value={registerData.email}
            onChange={handleRegisterChange}
            required
        />


        <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={registerData.phone}
            onChange={handleRegisterChange}
            required
        />


        <input
            type="text"
            name="securityKey"
            placeholder="Unique Security Key"
            value={registerData.securityKey}
            onChange={handleRegisterChange}
            required
        />


        <input
            type="password"
            name="password"
            placeholder="Password"
            value={registerData.password}
            onChange={handleRegisterChange}
            required
        />


        <input
            type="password"
            name="confirmPassword"
            placeholder="Confirm Password"
            value={registerData.confirmPassword}
            onChange={handleRegisterChange}
            required
        />


    </div>



    <button
        className="btn-register-logadmin"
        disabled={loading}
    >

        {
            loading
            ? "Creating Account..."
            : "REGISTER ADMIN"
        }

    </button>


</form>


        )}



        {/* Footer */}

        <div className="footer-logadmin">

            <div className="secure-dot-logadmin"></div>

            Protected by Enterprise Security

        </div>


    </div>


</div>
);
}